import {LearningPackageStudyProgressResponseDto} from '../../../types/LearningPackageStudyProgressResponseDto';
import {InsightTabs} from './InsightTabs';

export class InsightPopupData {

    constructor(public currentTab: InsightTabs,
                public studyProgress: LearningPackageStudyProgressResponseDto) {
    }
}
